import React from "react";
import { Link } from "react-router-dom";
import img from "../../../assets/images/image_2023.png"
import useAuth from "../../../hooks/useAuth";

const Logo = () => {
    const {auth} = useAuth();
  return (
    <>
      <div className="logo">
        <Link to="/DashboardData">
          { <img
            src={img}
            alt="P.UP"
          /> }
            <span>&nbsp;</span>
            {auth?.partner_logo &&
                <img src={auth?.partner_logo} alt="logo"/>
            }
        </Link>
      </div>
    </>
  );
};

export default Logo;
